/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { Box, Button, IconButton, Switch, Tooltip } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import AddCategory from "../../Modals/addCategory";
import { useNavigate } from "react-router-dom";

import moment from "moment";
import { ConfirmationModal } from "../../Modals/confirmationModal";
import {
  useLazyDeleteCategoryQuery,
  useReorderingApiMutation,
} from "../../services/category";
import { showError, showToast } from "../../constants/toasts";
import { getFromStorage } from "../../helpers/storage";
import { STORAGE_KEYS } from "../../constants/storageKeys";
import usePermission from "../../hooks/usePermission";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { SortableItem } from "../../components/SortableItem";
import { CATEGORY_TYPE } from "../../utils/enums";
import Pagination from "../../components/Panigation";
import useTranslation from "../../hooks/traslation";

type props = {
  open: boolean;
  openDelete: boolean;
  setOpenDelete: Dispatch<SetStateAction<boolean>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSelctedId: Dispatch<SetStateAction<string>>;
  name: string;
  price: string;
  image: string;
  rows: any;
  openDetails: boolean;
  setOpenDetails: Dispatch<SetStateAction<boolean>>;
  setSelectedId: Dispatch<SetStateAction<string>>;
  setImage: Dispatch<SetStateAction<string>>;
  setName: Dispatch<SetStateAction<string>>;
  setPrice: Dispatch<SetStateAction<string>>;
  handleStatusChange: (id: string, status: boolean) => Promise<void>;
  isLoading: boolean;
  setDescription: Dispatch<SetStateAction<string>>;
  setDescriptionAr: Dispatch<SetStateAction<string>>;
  setNameAr: Dispatch<SetStateAction<string>>;
  nameAr: string;
  descriptionAr: string;
  setRows: Dispatch<SetStateAction<any>>;
  handlePageChange: (event: any, newPage: number) => void;
  setPage: Dispatch<SetStateAction<number>>;
  page: number;
  totalCount: number;
};

const CategoryList = ({
  setOpen,
  handleStatusChange,
  setOpenDetails,
  setSelctedId,
  setImage,
  setPrice,
  setName,
  setDescription,
  setOpenDelete,
  rows,
  isLoading,
  setDescriptionAr,
  setNameAr,
  setSelectedId,
  setRows,
  totalCount,
  handlePageChange,
  page,
  setPage,
}: props) => {
  const navigate = useNavigate();
  const getLang = getFromStorage(STORAGE_KEYS.language);
  const [reorderMethod] = useReorderingApiMutation();
  const translate = useTranslation();

  const { isAdd, isDelete } = usePermission({
    label: "Manage Categories",
    page_permission: "isView",
  });

  const sensors = useSensors(useSensor(PointerSensor));

  const onPageChange = (newPage: number) => {
    setPage(newPage);
  };
  const handleReording = async (updatedItem: any) => {
    const body = {
      type: CATEGORY_TYPE.CATEGORY,
      category: updatedItem || [],
    };
    try {
      // const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await reorderMethod(body).unwrap();

      if (response?.statusCode === 200) {
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      console.log(error);
    }
  };

  const handleDragEnd = (event: any) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = rows?.findIndex((item: any) => item._id === active.id);
      const newIndex = rows?.findIndex((item: any) => item._id === over.id);

      const newItems = arrayMove(rows, oldIndex, newIndex);

      // Add serialNo based on new order
      const updatedItems = newItems.map((item: any, index: number) => ({
        ...item,
        serialNo: index + 1,
      }));

      setRows(updatedItems);
      handleReording(updatedItems);
    }
  };

  const label = { inputProps: { "aria-label": "Switch demo" } };
  let totalPages = Math.ceil(totalCount / 10);

  return (
    <>
      <div className="sorting_table">
        <DndContext
          sensors={sensors}
          collisionDetection={closestCenter}
          onDragEnd={handleDragEnd}
        >
          <SortableContext
            items={rows?.map((item: any) => item._id)}
            strategy={verticalListSortingStrategy}
          >
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>{translate?.main?.sort}</th>
                  <th>{translate?.main?.Image}</th>
                  <th>{translate?.globals?.name}</th>
                  <th>{translate?.main?.createdAt}</th>
                  <th>{translate?.main?.subServices}</th>
                  <th>{translate?.globals?.status}</th>
                  <th>{translate?.globals?.actions}</th>
                </tr>
              </thead>
              <tbody>
                {rows?.length ? (
                  rows?.map((row: any, index: any) => (
                    <SortableItem
                      key={row._id}
                      row={row}
                      index={index}
                      render={(item: any, dragProps: any) => (
                        <tr ref={dragProps.ref} style={{ ...dragProps.style }}>
                          <td style={{ cursor: "grab" }}>
                            <span
                              {...dragProps.listeners}
                              {...dragProps.attributes}
                              style={{
                                cursor: "grab",
                                display: "inline-block",
                                padding: "0 8px",
                                userSelect: "none",
                                fontSize: "30px",
                              }}
                            >
                              <img
                                src="/static/images/dragUp.png"
                                style={{ width: 20, height: 20 }}
                              />
                            </span>
                          </td>
                          <td>
                            <div className="tbl_clm">
                              <img
                                src={item?.image}
                                style={{
                                  width: 40,
                                  height: 40,
                                  verticalAlign: "middle",
                                }}
                              />
                            </div>
                          </td>

                          <td>{item?.name || ""}</td>
                          <td>
                            {moment(item?.createdAt).format("DD MMM YYYY")}
                          </td>
                          <td>
                            <Button
                              className="btn sm btn_primary"
                              onClick={() =>
                                navigate(
                                  `/manage-categories/subcategory/${item?._id}`
                                )
                              }
                            >
                              {translate?.main?.view}
                            </Button>
                          </td>
                          <td>
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <Switch
                                {...label}
                                size="small"
                                checked={item?.status}
                                onChange={() =>
                                  handleStatusChange(item?._id, !item?.status)
                                }
                                disabled={isLoading}
                              />
                            </Box>
                          </td>
                          <td>
                            <div className="table_actions v2">
                              <div className="table_actions v2">
                                <Box>
                                  <Tooltip title="View">
                                    <IconButton
                                      onClick={() => {
                                        setOpenDetails(true);
                                        setSelctedId(row?._id);
                                        setImage(row?.image);
                                        setName(row?.name);
                                        setNameAr(row?.name_ar);
                                        setDescription(row?.description);
                                        setDescriptionAr(row?.description_ar);
                                      }}
                                    >
                                      <img
                                        src="/static/images/eye_icon.svg"
                                        alt=""
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Box>
                                {isAdd ? (
                                  <Box>
                                    <Tooltip title="Edit">
                                      <IconButton
                                        onClick={() => {
                                          setSelctedId(row?._id);
                                          setImage(row?.image);
                                          setName(row?.name);
                                          setPrice(row?.startPrice);
                                          setDescription(row?.description);
                                          setOpen(true);
                                          setNameAr(row?.name_ar);
                                          setDescriptionAr(row?.description_ar);
                                        }}
                                      >
                                        <img
                                          src="/static/images/edit2_icon.svg"
                                          alt=""
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                ) : null}

                                {isDelete ? (
                                  <Box>
                                    <Tooltip title="Delete">
                                      <IconButton
                                        onClick={() => {
                                          setSelctedId(row?._id);
                                          setOpenDelete(true);
                                        }}
                                      >
                                        <img
                                          src="/static/images/trash2_icon.svg"
                                          alt=""
                                        />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                ) : null}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    />
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={7}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      {translate?.auth?.noDataFound}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </SortableContext>
        </DndContext>
        {rows?.length > 0 ? (
          <Pagination
            setPage={setPage}
            module={rows}
            page={page}
            onPageChange={onPageChange}
            totalPages={totalPages}
          />
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default CategoryList;
